import { BaseService } from "./BaseService";
import { Param, Root } from "../types/app.interfaces";

export class InvestmentService extends BaseService {
  getInvestments(portfolioType: string, profileId: string, portfolioId: string, selectionSetId: string): any {
    const xx: Param = {
      measures: [],
      dpsid_data_area_type: portfolioType,
      dpsid_all_portfolios: false,
      dpsid_portfolio_id: portfolioId.toString(),
      userGUID: profileId.toString(),
      includeCommitment: false,
      initialLoad: false,
      dpsid_selection_set_id: selectionSetId,
    };

    const payload: Root = {
      parameters: xx,
    };

    return super.invokePost(
      this.APICONFIG.APIBASEURL + this.APICONFIG.GETINVESTMENTS + "?profileID=" + profileId + "&type=json",
      payload
    );
  }
  getSelectionSets(profileId) {
    return super.invokeGet(this.APICONFIG.APIBASEURL + this.APICONFIG.SELECTIONSET + "?profileID=" + profileId);
  }
}
